import { calculateJobTotalsLegacy } from "@/dentlab/src/lib/utils/calculate";
import {
	JobDocumentEntityType,
	JobEntityType,
	JobItemEntityType,
} from "@/lib/supabase/supabaseTypes";
import {
	OrganizationEntityType,
	ClientEntityType,
} from "@/lib/supabase/supabaseTypes";

export interface TotalRow {
	name: string;
	value: string;
	bold?: boolean;
	borderBottom?: boolean;
}

export const buildTotalRows = ({
	jobItems,
	jobDocument,
	job,
	organization,
	client,
}: {
	jobItems: JobItemEntityType[];
	jobDocument: JobDocumentEntityType;
	job: JobEntityType;
	organization: OrganizationEntityType | null;
	client: ClientEntityType | null;
}): { rows: TotalRow[]; totalText: string } => {
	const {
		total,
		mwst,
		amountMaterials,
		amountWorkAndFixedRate,
		deductions,
		taxpunkte,
		amountPostage,
		amountExternalWork,
		deductionsWorkAndFixedRate,
		deductionsMaterials,
		subTotal,
	} = calculateJobTotalsLegacy({
		job,
		jobDocument,
		jobItems,
		organization: organization!,
		client: client!,
	});

	const rows: TotalRow[] = [
		{ name: "Arbeit", value: amountWorkAndFixedRate.text, bold: true },
		{ name: "ArbeitTP", value: taxpunkte.text },
		{ name: "Material", value: amountMaterials.text, bold: true },
		{ name: "Fremdarbeiten", value: amountExternalWork.text },
		{ name: "Porto", value: amountPostage.text, borderBottom: true },
		{ name: "Abzüge Arbeit", value: deductionsWorkAndFixedRate.text },
		{ name: "Abzüge Material", value: deductionsMaterials.text },
		{
			name: "Abzüge Gesamt",
			value: deductions.text,
			bold: true,
			borderBottom: true,
		},
		{ name: "Subtotal", value: subTotal.text },
		{ name: "MwSt.", value: mwst.text },
		{ name: "Total", value: total.text, bold: true },
	];

	return { rows, totalText: total.text };
};
